import React, { useEffect, useState } from 'react';
import { getClassName } from '@onsolve/utils.get-class-name';
import { Radio, RadioGroup, TextArea, Typography } from '@onsolve/onsolve-ui-components';
import { t } from '@lingui/macro';
import styles from './Followup.module.scss';
const Followup = ({ currentFollowUp, handleResponseOptionChange, handleTextAreaChange, isSaveBtnDisabled, key, }) => {
    const [rootClass, getChildClass] = getClassName({
        rootClass: 'followUp-page',
        styles,
    });
    const [selectedValue, setSelectedValue] = useState(undefined);
    const [textareaValue, setTextareaValue] = useState(undefined);
    useEffect(() => {
        if (currentFollowUp && currentFollowUp['response'] && currentFollowUp.choice.length > 0) {
            setSelectedValue(currentFollowUp['response']);
            isSaveBtnDisabled(false);
        }
        else if (currentFollowUp && currentFollowUp['response'] && currentFollowUp.choice.length === 0) {
            setTextareaValue(currentFollowUp['response']);
            isSaveBtnDisabled(false);
        }
    }, []);
    const handleRadioSelectionChange = (_, selectionValue) => {
        isSaveBtnDisabled(false);
        setSelectedValue(selectionValue?.value);
        handleResponseOptionChange(selectionValue?.value);
    };
    const handleTextChange = (_, textAreaValue) => {
        isSaveBtnDisabled(false);
        if (!textAreaValue)
            isSaveBtnDisabled(true);
        setTextareaValue(textAreaValue);
        handleTextAreaChange(textAreaValue);
    };
    return (<div className={`${rootClass} mb-5`}>
            <div className={`mb-3 ${getChildClass('response-question')}`}>
                <div className={getChildClass('response-index')}>{currentFollowUp['serialNumber']}</div>
                <Typography variant={'p16'} className="mb-0 pl-3">
                    {currentFollowUp?.verbiage?.text[0]?.value}
                </Typography>
            </div>
            {currentFollowUp?.choice && currentFollowUp?.choice?.length > 0 && (<RadioGroup value={selectedValue} onChange={handleRadioSelectionChange} className={'ml-1'} name={'responseOption'}>
                    {currentFollowUp?.choice?.map((choice) => (<Radio className="mb-2" key={choice.id} label={choice?.verbiage?.text[0]?.value} value={choice.id} type={'radio'}/>))}
                </RadioGroup>)}

            {currentFollowUp?.choice && currentFollowUp?.choice?.length === 0 && (<TextArea className={`${getChildClass('response-textarea')} mb-2`} rows={3} label={t `Write your answer.`} value={textareaValue} onChange={handleTextChange} placeholder={t `Enter your answer`}/>)}
        </div>);
};
export default Followup;
